@for (star of _data | times; track $index) {
  <mat-icon class="filled-star">star_rate</mat-icon>
}
@for (star of blank | times; track $index) {
  <mat-icon class="blank-star">star_border</mat-icon>
}
